// 9fbef606107a605d69c0edbcd8029e5d
import { STYLITICS_PRODUCT_TAB_LIST_ACTION_PATTERN } from '@tcp/core/src/constants/reducer.constants';

export default {
  STYLITICS_PRODUCT_TAB_LIST_REQ: `${STYLITICS_PRODUCT_TAB_LIST_ACTION_PATTERN}STYLITICS_PRODUCT_TAB_LIST_REQ`,
  STYLITICS_PRODUCT_TAB_LIST_SUCCESS: `${STYLITICS_PRODUCT_TAB_LIST_ACTION_PATTERN}STYLITICS_PRODUCT_TAB_LIST_SUCCESS`,
  STYLITICS_PRODUCT_TAB_LIST_FAIL: `${STYLITICS_PRODUCT_TAB_LIST_ACTION_PATTERN}STYLITICS_PRODUCT_TAB_LIST_FAIL`,
  STYLITICS_PRODUCT_TAB_LIST_REQ_OUTFIT: `${STYLITICS_PRODUCT_TAB_LIST_ACTION_PATTERN}STYLITICS_PRODUCT_TAB_LIST_REQ_OUTFIT`,
  IS_FETCHING_DATA_FOR_OUTFIT: `${STYLITICS_PRODUCT_TAB_LIST_ACTION_PATTERN}IS_FETCHING_DATA_FOR_OUTFIT`,
  STYLITICS_FLUSH_DATA: `${STYLITICS_PRODUCT_TAB_LIST_ACTION_PATTERN}STYLITICS_FLUSH_DATA`,
  OUTFIT_PLP_DATA_SUCCESS: `${STYLITICS_PRODUCT_TAB_LIST_ACTION_PATTERN}OUTFIT_PLP_DATA_SUCCESS`,
  OUTFIT_PLP_DATA_FAIL: `${STYLITICS_PRODUCT_TAB_LIST_ACTION_PATTERN}OUTFIT_PLP_DATA_FAIL`,
  SET_OUTFIT_SEO_DATA: `${STYLITICS_PRODUCT_TAB_LIST_ACTION_PATTERN}SET_OUTFIT_SEO_DATA`,
  BAG_OUTFIT_PRODUCTS: `${STYLITICS_PRODUCT_TAB_LIST_ACTION_PATTERN}BAG_OUTFIT_PRODUCTS`,
  STYLITICS_PRODUCT_TAB_LIST_BAG: `${STYLITICS_PRODUCT_TAB_LIST_ACTION_PATTERN}STYLITICS_PRODUCT_TAB_LIST_BAG`,
};
